import React from "react";
import PropTypes from 'prop-types';
import RadioButton from "ui-coopeuch-radio-button";
import IconArrowBottom from "../../../assets/img/icon/icon-arrow-bottom.svg";
import IconArrowUp from "../../../assets/img/icon/icon-arrow-top.svg";
import IconHorario from "../../../assets/img/icon/icon-horario.svg";
import {CollapseItemWrapper} from './styles';
import { capitalize, capitalizeEachWord } from '../../../../utils';

const CollapseItem = props => {
  const {
    list,
    onSelectItem,
    activeIndex

  } = props;

 

  return (

    <>
      { 
        list.map((item, index)=>{
          return(
            <CollapseItemWrapper key={item.codigoOficina}>
              <section className="item-container" id="collapseCard">
                <button
                  className={`item-container-header ${activeIndex === index ? 'Accordion-item-open': ''}`}
                  type="button"
                  onClick={() => {
                    onSelectItem(item, index)
                  }}

                >
                  <hgroup>
                    <RadioButton name="radioButton" label={capitalizeEachWord(item.sucursalName)} value={item.sucursalName} isChecked={activeIndex === index} />
                    <p className="direccion">{capitalize(item.direccion)}</p>
                  </hgroup>
                  <article className="AccordionItem--collapsed-indicator">
                  
                    {activeIndex === index ? 
                      (
                        <img src={IconArrowUp} alt="arrow-top" />
                      ) : (
                        <img src={IconArrowBottom} alt="arrow-top" />
                      )}
                  </article>
                </button>
                

                {
                  activeIndex === index &&
                  <section className="AccordionItem--content">
                    <div className="container-horario-icon">
                      <img src={IconHorario} alt="horario" />
                    </div>
                    <div>
                      <p>
                        <span>
                          {`Horarios: `}
                        </span>
                        {item.horario.substr(0, item.horario.indexOf('Viernes'))}
                      </p>
                      <p>
                        {item.horario.substr(item.horario.indexOf('Viernes'))}
                      </p>
                    </div>
                  </section>
                }
                
              </section>

            </CollapseItemWrapper>
            
          )
        })
      }
      
    </>
    
  );
};

CollapseItem.propTypes = {
  list: PropTypes.arrayOf(PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number,
    sucursal: PropTypes.string,
    codigoOficina: PropTypes.number,
    direccion: PropTypes.string,
    horario: PropTypes.string

  })).isRequired,
  onSelectItem: PropTypes.func.isRequired,
  activeIndex: PropTypes.number
  
};

CollapseItem.defaultProps = ({
  activeIndex: null
});



export default CollapseItem;